import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';
import useAuthContext from '../../contexts/AuthContext';
import useHandleResize from '../../utils/HandleResize';
import navMenuLogos from '../../utils/constants/navMenuLogos';
import { routesSiderRight, outOfNavRoutes } from '../../utils/constants/routes';
import useAssurmaxContext from '../../contexts/AssurmaxContext';

const NavMenuSiderRight = ({ insurer, path, setCollapsed }) => {
  const { width } = useHandleResize();
  const { t } = useTranslation();
  const { dispatchAPI, user } = useAuthContext();
  const assurmaxContext = useAssurmaxContext();

  const handleClick = ({ key }) => {
    if (key === 'logout') {
      dispatchAPI('LOGOUT');
    }
  };

  return (
    <Menu
      style={{
        padding: '16px 0',
        background: 'var(--clientColor)'
      }}
      selectedKeys={[path]}
      defaultOpenKeys={[path.split('/')[1]]}
      mode="inline"
      onSelect={width < 992 ? () => setCollapsed(true) : () => {}}
      onClick={handleClick}
    >
      {insurer &&
        Object.entries(routesSiderRight).map(([menuItem, p]) => {
          const isGroupHead =
            menuItem === 'BROKER_GROUP' &&
            !(
              user?.insurer?.group &&
              user?.insurer?.group?.head_insurer &&
              String(
                user?.insurer?.group?.head_insurer?._id ||
                  user?.insurer?.group?.head_insurer
              ) === String(user?.insurer?._id)
            );

          return (
            <Menu.Item key={p} disabled={p === '' || isGroupHead}>
              <NavLink
                to={`${outOfNavRoutes.SETTINGS}${p}/${
                  p === '/brokercompliance' ? user?.insurer?._id : ''
                }`}
              >
                {navMenuLogos[menuItem]}
                <span>
                  {t(`basiclayout.menu.${menuItem.toLowerCase()}`)}
                  {assurmaxContext[menuItem]
                    ? ` (${assurmaxContext[menuItem]})`
                    : ''}
                </span>
              </NavLink>
            </Menu.Item>
          );
        })}
    </Menu>
  );
};

NavMenuSiderRight.propTypes = {
  path: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  insurer: PropTypes.object.isRequired,
  setCollapsed: PropTypes.func.isRequired
};

export default NavMenuSiderRight;
